import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  console.error('REACT_APP_BACKEND_URL is not set. API calls will fail.');
}
const API_URL = (BACKEND_URL || 'http://localhost:8000') + '/api';

export const api = axios.create({
  baseURL: API_URL,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

// Global 401 response interceptor - clear token and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Tasks
export const getTasks = () => api.get('/tasks');
export const getTask = (taskId) => api.get(`/tasks/${taskId}`);
export const getTasksByUser = (userId) => api.get(`/tasks/by-user/${userId}`);
export const getAllTasksByUsers = () => api.get('/tasks/all-by-users');
export const createTask = (taskData) => api.post('/tasks', taskData);
export const updateTask = (taskId, taskData) => api.patch(`/tasks/${taskId}`, taskData);
export const deleteTask = (taskId) => api.delete(`/tasks/${taskId}`);

// Users
export const getUsers = () => api.get('/users');
export const deleteUser = (userId) => api.delete(`/users/${userId}`);

// User Status
export const updateMyStatus = () => api.patch('/users/me/status');
export const requestLeave = (leaveData) => api.post('/users/me/leave', leaveData);
export const cancelLeave = () => api.delete('/users/me/leave');
export const logoutUser = () => api.post('/users/me/logout');

// Notifications
export const getNotifications = () => api.get('/notifications');
export const markNotificationRead = (notificationId) => api.patch(`/notifications/${notificationId}/read`);
export const markAllNotificationsRead = () => api.post('/notifications/mark-all-read');

// Stats
export const getDashboardStats = () => api.get('/stats/dashboard');

// Setup
export const createInitialAdmin = () => api.post('/setup/initial-admin');

// Clients
export const getClients = () => api.get('/clients');
export const getClient = (clientId) => api.get(`/clients/${clientId}`);
export const createClient = (clientData) => api.post('/clients', clientData);
export const updateClient = (clientId, clientData) => api.patch(`/clients/${clientId}`, clientData);
export const deleteClient = (clientId) => api.delete(`/clients/${clientId}`);

// Content Calendars
export const getCalendars = (params) => api.get('/calendars', { params });
export const createCalendar = (clientId, month, year) => api.post('/calendars', null, { params: { client_id: clientId, month, year } });
export const submitCalendar = (calendarId) => api.patch(`/calendars/${calendarId}/submit`);
export const reviewCalendar = (calendarId, reviewData) => api.post(`/calendars/${calendarId}/review`, reviewData);

// Content Posts
export const getContentPosts = (params) => api.get('/content-posts', { params });
export const createContentPost = (postData) => api.post('/content-posts', postData);
export const updateContentPost = (postId, postData) => api.patch(`/content-posts/${postId}`, postData);
export const deleteContentPost = (postId) => api.delete(`/content-posts/${postId}`);

// Post Comments
export const getPostComments = (postId) => api.get(`/content-posts/${postId}/comments`);
export const createPostComment = (postId, commentData) => api.post(`/content-posts/${postId}/comments`, commentData);

// Post Versions
export const getPostVersions = (postId) => api.get(`/content-posts/${postId}/versions`);

// File Upload
export const uploadFile = (fileData) => api.post('/upload-file', fileData);